import React from 'react'
import { Row, Col, Progress } from 'antd'
import styles from './ProgressSteps.module.css'

const ProgressSteps = ({ step, totalSegments }) => {
  const getSegmentPercent = index => Math.max(0, Math.min(1, step - index)) * 100

  const colSpan = 24 / totalSegments 

  return (
    <div className={styles.progressWrapper}>
      <Row gutter={[8, 0]}>
        {Array.from({ length: totalSegments }, (_, i) => (
          <Col key={i} span={colSpan} className={styles.progressItem}>
            <Progress
              percent={getSegmentPercent(i)}
              showInfo={false}
              strokeWidth={3}
              strokeColor="#0b7285"
              trailColor="#e5e7eb"
              size="small"
            />
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default ProgressSteps;